import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RelatorioCoafService } from './relatorio-coaf-service/relatorio-coaf.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { Table } from 'primeng/table';
import { RelatorioCoafFiltroService } from './relatorio-coaf-service/relatorio-coaf-filtro.service';
import { FiltroDealers } from './relatorio-coaf-service/filtro-dealer';

@Component({
  selector: 'app-relatorio-coaf',
  templateUrl: './relatorio-coaf.component.html',
  styleUrls: ['./relatorio-coaf.component.scss']
})
export class RelatorioCoafComponent implements OnInit {
  @Input() filtros: any;
  form: FormGroup;
  subscription: any;
  cols: any[];
  _selectedColumns: any[];
  dados: any[] = [];
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  gruposEconomicos = [];
  filtrosDealers: FiltroDealers;
  globalFilterFields: string[] = [];

  @ViewChild('dt') dt: Table;

  constructor(private service: RelatorioCoafService,
    public translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: RelatorioCoafFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder) {

    this.filtros = {};
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      grupo_economico: [[]],
      valor: [''],
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.preencherGruposEconomicos();
    this.loading = true;
    this.inicializarColunas();
    this._selectedColumns = this.cols;
    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private inicializarColunas() {
    this.cols = [
      { field: 'empresaConta', header: 'businessIntelligence.relatorioCoaf.empresaConta', width: '110px' },
      { field: 'nomeDealer', header: 'businessIntelligence.relatorioCoaf.nomeDealer', width: '200px' },
      { field: 'nomeEmpresa', header: 'businessIntelligence.relatorioCoaf.nomeEmpresa', width: '200px' },
      { field: 'ano', header: 'businessIntelligence.relatorioCoaf.ano', width: '80px' },
      { field: 'status', header: 'businessIntelligence.relatorioCoaf.status', width: '120px' },
      { field: 'numeroNota', header: 'businessIntelligence.relatorioCoaf.numeroNota', width: '110px' },
      { field: 'dataOperacao', header: 'businessIntelligence.relatorioCoaf.dataOperacao', width: '160px', type: 'date' },
      { field: 'uf', header: 'businessIntelligence.relatorioCoaf.uf', width: '70px' },
      { field: 'tipoOperacao', header: 'businessIntelligence.relatorioCoaf.tipoOperacao', width: '150px' },
      { field: 'valorOperacao', header: 'businessIntelligence.relatorioCoaf.valorOperacao', width: '140px', type: 'currency' },
      { field: 'formaPagamento', header: 'businessIntelligence.relatorioCoaf.formaPagamento', width: '150px' },
      { field: 'valorEspecia', header: 'businessIntelligence.relatorioCoaf.valorEspecia', width: '130px', type: 'currency' },
      { field: 'recebimentoPagamento', header: 'businessIntelligence.relatorioCoaf.recebimentoPagamento', width: '180px' },
      { field: 'descricaoMercadoria', header: 'businessIntelligence.relatorioCoaf.descricaoMercadoria', width: '220px' },
      { field: 'chaveAcessoNfe', header: 'businessIntelligence.relatorioCoaf.chaveAcessoNfe', width: '280px' },
      { field: 'compradorConsignante', header: 'businessIntelligence.relatorioCoaf.compradorConsignante', width: '180px' },
      { field: 'nome', header: 'businessIntelligence.relatorioCoaf.nome', width: '180px' },
      { field: 'documento', header: 'businessIntelligence.relatorioCoaf.documento', width: '150px' },
      { field: 'tipoCliente', header: 'businessIntelligence.relatorioCoaf.tipoCliente', width: '130px' },
      { field: 'numero', header: 'businessIntelligence.relatorioCoaf.numero', width: '120px' },
      { field: 'orgaoExpedidor', header: 'businessIntelligence.relatorioCoaf.orgaoExpedidor', width: '150px' },
      { field: 'ufDocumento', header: 'businessIntelligence.relatorioCoaf.ufDocumento', width: '70px' },
      { field: 'endereco', header: 'businessIntelligence.relatorioCoaf.endereco', width: '220px' },
      { field: 'pessoaPoliticamenteExposta', header: 'businessIntelligence.relatorioCoaf.pessoaPoliticamenteExposta', width: '220px' },
      { field: 'nomePreposto', header: 'businessIntelligence.relatorioCoaf.nomePreposto', width: '180px' },
      { field: 'documentoPreposto', header: 'businessIntelligence.relatorioCoaf.documentoPreposto', width: '150px' },
      { field: 'numeroPreposto', header: 'businessIntelligence.relatorioCoaf.numeroPreposto', width: '120px' },
      { field: 'orgaoPreposto', header: 'businessIntelligence.relatorioCoaf.orgaoPreposto', width: '150px' },
      { field: 'ufPreposto', header: 'businessIntelligence.relatorioCoaf.ufPreposto', width: '150px' },
    ];

    this.globalFilterFields = this.cols.map(c => c.field);
  }

  private getAll() {
    this.loading = true;
    const grupos = this.f.grupo_economico.value?.length
      ? this.f.grupo_economico.value.join(',')
      : '';

    this.service.getDados(
      this.f.data_inicial.value,
      this.f.data_final.value,
      this.f.dealers.value,
      grupos,
      this.f.valor.value
    ).subscribe(dados => {
      this.dados = dados.dados || [];
      this.dados.forEach((element, index) => this.formatarDados(element, index));
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  private formatarDados(element: any, index: number) {
    element._rowId = `${element.empresaConta}_${element.numeroNota}_${index}`;

    if (element.dataOperacao != null) {
      element.dataOperacaoFormatada = moment(new Date(element.dataOperacao)).format('DD/MM/YYYY HH:mm');
    }

    ['valorOperacao', 'valorEspecia'].forEach(campo => {
      if (element[campo] != null) {
        const atual = this.conversaoLibraConverte.conversaoLibra(element[campo], null, null);
        element[campo] = atual;
        element[campo + 'Formatado'] = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
      }
    });

    // Prepare a short preview and a hover hint for descricaoMercadoria
    if (element.descricaoMercadoria != null) {
      const parts = element.descricaoMercadoria
        .split(';')
        .map((p: string) => p.trim())
        .filter((p: string) => p.length > 0);

      element.descricaoMercadoriaPreview = parts.length > 0 ? parts[0] : '';
      element.descricaoMercadoriaHint = parts.length > 1 ? parts.slice(1).join('; ') : '';
    }
  }

  public getValorCelula(row: any, col: any) {
    if (col.type === 'currency') {
      return row[col.field + 'Formatado'] ?? row[col.field];
    }
    if (col.type === 'date') {
      return row[col.field + 'Formatada'] ?? row[col.field];
    }
    return row[col.field];
  }

  private tratarData() {
    const hoje = new Date();
    this.dataInicial = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.dataFinal = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  }

  public filtroAPI() {
    this.loading = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
    this.displayFiltros = false;
  }

  private filtrosSelecionados() {
    const dealers = [];
    this.incluirFiltroDealers(dealers);
    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public getListagemComFiltros(): boolean {
    return !!this.f.valor.value || this.f.grupo_economico.value?.length > 0;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  public limparFiltros() {
    this.f.valor.setValue('');
    this.f.grupo_economico.setValue([]);
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  private translateHeader(col: any) {
    return this.translate.instant(col.header);
  }

  public exportExcel() {
    if (this.dados.length > 0) {
      const colunasFormatacao = [];
      this._selectedColumns.forEach((c, i) => {
        if (c.type === 'currency') {
          colunasFormatacao.push(i);
        }
      });

      this.exportExcelService.nomeModulo = 'Relatório COAF';
      this.exportExcelService.colunasFormatacao = colunasFormatacao;
      this.exportExcelService.formatType = '"R$"#,##0.00';
      this.exportExcelService.ExportTOExcelJSON(this.dados.map(r => {
        let linha = {};

        this._selectedColumns.forEach(c => {
          if (c.type === 'currency') {
            linha[this.translateHeader(c)] = r[c.field];
          } else if (c.type === 'date') {
            linha[this.translateHeader(c)] = r.dataOperacaoFormatada ?? r[c.field];
          } else {
            linha[this.translateHeader(c)] = r[c.field];
          }
        });

        return linha;
      }));
    }
  }

  private preencherGruposEconomicos() {
    this.servico.getFiltroGrupoEconomico()
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

}
